export default __webpack_public_path__ + "static/media/image1.d17b36d8.png";